import axios from 'axios'

export const getProvincias = async () => {
  const axiosUrl = '/domicilio/provincias'
  const { data } = await axios.get(axiosUrl)
  return data
}

export const getLocalidades = async (provincia: string) => {
  const axiosUrl = '/domicilio/localidades'
  const { data } = await axios.get(`${axiosUrl}?provincia=${provincia}`)
  return data
}
